import SizeTips from "../../assets/size-tips.png";

const ItemSizeView = ({
  value = { shape: "cube", cubeX: 0, cubeY: 0, cubeZ: 0 },
  unit = "mm",
}) => {
  return (
    <div
      className={
        value.shape === "multi" ? "flex-1" : "flex flex-1 items-center"
      }
    >
      <span className="pr-2">({value.shape})</span>
      {value.shape === "multi" ? (
        <div className="w-full mt-2">{value.multiSizes}</div>
      ) : (
        <div className="flex items-center">
          {value.shape === "ball" ? (
            <>
              <span>{value.ballDiameter}</span>
              <span className="ml-2">{unit}</span>
            </>
          ) : value.shape === "cube" ? (
            <>
              <span className="text-center">{value.cubeX}</span>
              <span className="px-4">&times;</span>
              <span className="text-center">{value.cubeZ}</span>
              <span className="px-4">&times;</span>
              <span className="text-center">{value.cubeY}</span>
              <span className="ml-2">{unit}</span>
              <div className="ml-4 flex items-center">
                <img src={SizeTips} className="h-8" alt="cub size tips" />
                <span className="ml-2 text-xs text-gray-500">
                  长(x) x 宽(z) x 高(y)
                </span>
              </div>
            </>
          ) : value.shape === "flat" ? (
            <>
              <span className="text-center">{value.flatX}</span>
              <span className="px-4">&times;</span>
              <span className="text-center">{value.flatY}</span>
              <span className="ml-2">{unit}</span>
            </>
          ) : value.shape === "cylindrical" ? (
            <>
              <span className="w-24 text-center">
                {value.cylindricalDiameter}
              </span>
              <span className="px-4">&times;</span>
              <span className="text-center">{value.cylindricalHeight}</span>
              <span className="ml-2">{unit}</span>
            </>
          ) : (
            <div>Unknown shape</div>
          )}
        </div>
      )}
    </div>
  );
};

export default ItemSizeView;
